export const isMd5 = (md5: string): boolean => {
  return /^[a-z0-9]{32}$/.test(md5)
}
